export const TIPO_RELACION = [
    { value: '01', label: '(01) Nota de crédito' },
    { value: '03', label: '(03) Devolución de mercancía' },
    { value: '07', label: '(07) Aplicación del anticipo' },
]

/** Bills shown per page on the "factura a relacionar" list */
export const RELATED_PAGE_LIMIT = 10;
